import { Fragment, type ReactNode } from "react";
import { usePayrollDisplaySettings } from "@/api/hooks/payroll";
import { setMoneyPrecision, type MoneyPrecision } from "@/shared/store/moneyFormat";

/** Applies the org-wide Rupees / Paisa display setting to its subtree. Sets
 *  the precision before children render and remounts them when it changes so
 *  memoized columns and derived strings pick up the new format. Falls back to
 *  whole rupees if the setting cannot be read. */
export function MoneyPrecisionScope({ children }: { children: ReactNode }) {
  const q = usePayrollDisplaySettings();
  if (q.isLoading) return null;
  const precision: MoneyPrecision = q.data?.moneyDisplay === "paisa" ? "paisa" : "rupees";
  setMoneyPrecision(precision);
  return <Fragment key={precision}>{children}</Fragment>;
}
